import firebase from 'firebase/app'


const populateSnapshot = (snapshot) => {
  const data = snapshot.data()

  return data ? {
    ...data,
    id: snapshot.id,
    created_at: data.created_at && data.created_at.toDate(),
  } : null
}


/**
 * Get a client by its id
 * @param {String} uid - The id of the client
 * @returns {Market} The market object
 */
const getClient = async (uid) => {
  const db = firebase.firestore()
  const snapshot = await db.collection('clients').doc(uid).get()

  return populateSnapshot(snapshot)
}


export default getClient
